import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Skeleton } from 'antd';
import { useParams } from 'react-router-dom';
import { EmployeeForm } from 'components';
import { getClientList, getLocations } from 'store/clientSlice';
import { getEmployeeByIdV2 } from 'store/employeeSliceV2';
import { search_type } from 'utils';
import { getZones } from 'utils/location';
import { Box } from 'atoms';
import { getUIVersion } from 'utils/router-static-data';

export default function Employee() {
	const [formData, setFormData] = useState({});
	const [zoneData, setZoneData] = useState([]);
	const [locationData, setLocationData] = useState();
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		// NOTE: V2 API does not support search_type: 'location'
		// Location data must be fetched using V1 API even when "New UI" is active
		// This is a known limitation of the V2 API
		dispatch(
			getLocations({
				search_type: search_type?.location,
				filter_by: {},
			})
		).then((res) => {
			setLocationData(res?.data);
			setZoneData(getZones(res?.data));
		});
	}, [dispatch]);

	useEffect(() => {
		if (id) {
			const uiVersion = getUIVersion();
			const useV2API = uiVersion === 'new';

			if (useV2API) {
				// V2 API: Use getEmployeeByIdV2
				dispatch(getEmployeeByIdV2({ id })).then((res) => {
					console.log('V2 res', res);
					setFormData(res || {});
				});
			} else {
				// V1 API: Use getClientList
				dispatch(
					getClientList({
						search_type: search_type?.user,
						filter_by: {
							id,
						},
					})
				).then((res) => {
					console.log('V1 res', res);
					setFormData(res?.data?.[0] || {});
				});
			}
		}
	}, [dispatch, id]);

	return (
		<Box>
			{locationData ? (
				<EmployeeForm
					isEditMode={Boolean(formData?.id)}
					formData={formData}
					zoneData={zoneData}
					locations={locationData}
				/>
			) : (
				<Skeleton />
			)}
		</Box>
	);
}
